var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRseaux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9994 18.4145V22.4145H15.9994V18.4145H19.9994V16.4145H7.99939V20.4145H3.99939V4.41451H7.99939V8.41451H23.9994C25.0603 8.41451 26.0777 8.83594 26.8278 9.58608C27.578 10.3362 27.9994 11.3536 27.9994 12.4145V18.4145H31.9994ZM19.9994 30.4145V36.4145C19.9994 37.4754 20.4208 38.4928 21.171 39.2429C21.9211 39.9931 22.9385 40.4145 23.9994 40.4145H39.9994V44.4145H43.9994V28.4145H39.9994V32.4145H27.9994V30.4145H31.9994V26.4145H15.9994V30.4145H19.9994Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRseaux);
export default __webpack_public_path__ + "static/media/Réseaux.4a1f4c1c63a3cfafe99595839434543a.svg";
export { ForwardRef as ReactComponent };